import useAffiliationSetupCards from './useAffiliationSetupCards'

export default { useAffiliationSetupCards }